<template>
  <div class="block28">
    <!-- 返回 -->
    <div class="return">
      <router-link to="/">
        <span class="arrow"></span>返回首页
      </router-link>
    </div>
    <!-- 返回 -->
    <!-- 内容 -->
    <div class="container">
      <h2 class="title1">曲轴箱通气管</h2>
      <div class="container-content">
        <p class="text_line">清洁曲轴箱通气管</p>
        <ul class="numberspace">
          <li>
            <em>1</em>拆下<router-link to="/block20/cehuzhao">左侧盖</router-link>。
          </li>
          <li>
            <em>2</em>从电池盒上取下<router-link to="/block33/baoxiansi">保险丝</router-link>盒。
          </li>
          <li>
            <em>3</em>在曲轴箱通气管下方放置一个盛油盘。
          </li>
          <li>
            <em>4</em>拆下曲轴箱通气管并排放出沉积物。
          </li>
          <li>
            <em>5</em>重新安装曲轴箱通气管。
          </li>
          <li>
            <em>6</em>安装的顺序与拆卸的顺序相反。
          </li>
        </ul>
        <img src="./img/img1.jpg" width="100%" />
      </div>
      <div class="foot-btn">
        <div class="prev">
          <router-link to="/block27">上一页</router-link>
        </div>
        <div class="next">
          <router-link to="/block29">下一页</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>